var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoInline = function SvgLogoInline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 333 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo-inline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m8.75 14.96 8.751 8.64-8.75 8.64L0 23.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A3CF",
    d: "M15.098 8.693 23.902 0 39 14.907 30.195 23.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M14.693 39.067 23.633 48 39 32.64V14.747z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A3CF",
    d: "M81.727 26.303H68.818v12.182H63V9.455h5.818v11.394h12.91V9.455h5.878v29.03h-5.879V26.273zM102.636 26.606 92.091 9.424h6.636l6.818 11.667 6.728-11.667h6.636l-10.454 17.152v11.879h-5.819v-11.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A3CF",
    fillRule: "evenodd",
    d: "M134.273 9.455h-10.788v29.03h10.788c8.575 0 14.515-5.727 14.515-14.485s-5.94-14.545-14.515-14.545m8.575 14.515c0 4.94-3.151 9.06-8.575 9.06h-4.97V14.88h4.97c5.606 0 8.575 3.97 8.575 9.121zM160.788 28.06h4.273l5.363 10.425h6.697l-6.151-11.06c2.939-.758 5.969-3.486 5.969-8.637 0-5.394-3.484-9.364-9.181-9.364H154.97v29.03h5.818zm0-13.302h6.091c2.333 0 4.091 1.575 4.091 4s-1.758 4-4.091 4h-6.091zM200.818 33.485l1.697 5h6.364l-10.546-29.03h-7.303l-10.575 29.03h6.393l1.728-5zm-1.636-5.364h-9.061l4.546-13.303z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A3CF",
    d: "M213.455 9.455h5.818V33.06h11.575v5.424h-17.393zM236.939 9.455h5.819v29.03h-5.819z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A3CF",
    fillRule: "evenodd",
    d: "M255.424 33.485h12.212l1.697 5h6.364l-10.515-29.03h-7.303l-10.576 29.03h6.394zm10.637-5.364H257l4.545-13.303z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A3CF",
    d: "M286.121 18.97v19.515h-5.818V9.455h5.97l12.666 18.818V9.455h5.819v29.03h-5.606zM313.545 29.697c1.94 2.152 4.91 3.91 8.697 3.91 3.213 0 4.758-1.607 4.758-3.274 0-2.181-2.394-2.909-5.545-3.697-4.455-1.09-10.182-2.394-10.182-8.878 0-4.819 3.939-8.758 10.363-8.758 4.334 0 7.94 1.394 10.637 4.06l-3.243 4.516c-2.212-2.182-5.151-3.182-7.818-3.182s-4.03 1.212-4.03 2.97c0 1.97 2.303 2.575 5.454 3.363 4.516 1.091 10.243 2.515 10.243 8.97 0 5.303-3.546 9.303-10.94 9.303-5.242 0-9.03-1.879-11.606-4.606z"
  }))));
};
export default SvgLogoInline;